// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2O4d4","noInteraction":"EventWrapper_noInteraction__zXkh6","pointerPassthrough":"EventWrapper_pointerPassthrough__6QCZk"};